// extracted by mini-css-extract-plugin
export default {"table":"mail-extractor_table__QmwhW","mailList":"mail-extractor_mailList__LbbrA","date":"mail-extractor_date__53dMK"};